export class Delegate{  
  VID:any;  
    delegates: any; 
    contractnumber:any[]; 
    contractname:any;

    UpdateContracts:any;
    UpdateDelegates :any;

  }